import graphqlClient from '~/graphql/graphqlClient';
import type { MutationEquipItemArgs, EquipItemResult } from 'dt-common/generated/graphql-types';

const mutation = `
mutation EquipItem(
  $playerId: String!
  $itemId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  equipItem(
    playerId: $playerId
    itemId: $itemId
    from: $from
    to: $to
  ) {
    heroHandle
    target_hero_builds
  }
}
`;

export default async function mutationEquipItem(
  args: MutationEquipItemArgs
): Promise<EquipItemResult> {
  return await graphqlClient.request<EquipItemResult>('equipItem', mutation, args);
}
